<template>
  <div class="stock_out_goods_box">
    <el-table
      v-if="list"
      ref="multipleTable"
      v-loading="tableLoading"
      border
      height="600"
      :data="list"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="goods_img"
        label="商品图片"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div style="width: 80px; height: 80px">
            <img
              :key="scope.row.goods_img[0]"
              :src="scope.row.goods_img[0]"
              style="width: 100%; height: 100%"
              @click="showImages(scope.row.goods_img)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="goods_name"
        label="商品名称"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="goods_kh"
        label="款号"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="sku"
        label="代采单价"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div class="p_container">
            <div
              v-for="item in scope.row.sku"
              v-if="scope.row.sku"
              class="p_table_box"
            >
              <p class="p_table">{{ item.price }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sku"
        label="颜色"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div class="p_container">
            <div
              v-for="item in scope.row.sku"
              v-if="scope.row.sku"
              class="p_table_box"
            >
              <p class="p_table">{{ item.co_val }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sku"
        label="尺码"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div class="p_container">
            <div
              v-for="item in scope.row.sku"
              v-if="scope.row.sku"
              class="p_table_box"
            >
              <p class="p_table">{{ item.si_val }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sku"
        label="恢复不断货"
        show-overflow-tooltip
        align="center"
        :width="150"
      >
        <template slot-scope="scope">
          <div class="p_container">
            <div
              v-for="item in scope.row.sku"
              v-if="scope.row.sku"
              class="p_table_box"
            >
              <p class="p_table">
                <el-input-number
                  v-model="item.c_num"
                  size="mini"
                  :max="Number(item.num)"
                  :min="0"
                ></el-input-number>
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sku"
        label="剩余"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div class="p_container">
            <div
              v-for="item in scope.row.sku"
              v-if="scope.row.sku"
              class="p_table_box"
            >
              <p
                v-if="Number(item.num) - Number(item.c_num) >= 0"
                class="p_table"
              >
                {{ Number(item.num) - Number(item.c_num) }}
              </p>
              <p
                v-if="Number(item.num) - Number(item.c_num) < 0"
                class="p_table"
              >
                0
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div
      style="
        background: #ffe235;
        line-height: 30px;
        display: flex;
        align-items: center;
      "
    >
      <el-button type="primary" size="mini" @click="resetData"
        >重置数量</el-button
      >
      <el-button
        style="margin-right: auto"
        type="primary"
        size="mini"
        @click="selectAll"
        >全选</el-button
      >
      <span
        >恢复不断货：共{{ statistic.Knum }}款，{{ statistic.num }}件，计¥{{
          statistic.amount
        }}</span
      >
    </div>
    <div>
      <el-button
        type="primary"
        style="float: right"
        size="mini"
        @click="recoveryData"
        >恢复不断货</el-button
      >
    </div>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../../components/PreviewImage.vue";
export default {
  components: { PreviewImage },
  props: {
    num: {
      type: Number,
      default: 0,
    },
    pgid: {
      type: Number,
      default: 0,
    },
    supply_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: true,
      tableLoading: false,
      list: [],
      images: [],
      showbox: false,
    };
  },
  computed: {
    statistic: function () {
      let goodsHh = {};
      let data = {
        num: 0,
        Knum: 0,
        amount: 0.0,
      };
      this.list.forEach((v, index) => {
        v.sku.forEach((n, m) => {
          if (n.c_num > 0) {
            goodsHh[v.goods_no] = 1;
            data.num += Number(n.c_num);
            data.amount += Number(n.c_num) * Number(n.price);
          }
        });
      });
      data.amount = parseFloat(data.amount).toFixed(2);
      data.Knum = Object.keys(goodsHh).length;
      // return "恢复不断货：共" + data.Knum + "款，" + data.num + "件，计¥" + data.amount;

      return data;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    handleSelectionChange() {},
    showImages(img) {
      this.images = img;
      this.showbox = true;
    },
    closeBox() {
      this.showbox = false;
    },
    fetchData() {
      let arg = {
        supply_id: this.supply_id,
        pgid: this.pgid,
      };
      this.$http.post("/erp/WcgPlan/stockGoodsList", arg).then((result) => {
        if (result.data.code != 200) {
          return this.$message.error(result.data.msg);
        }
        this.list = result.data.data;
        this.setPraentNum();
      });
    },

    setPraentNum() {
      let rs = 0;
      this.list.forEach((row) => {
        row.sku.forEach((sku) => {
          rs += Number(sku.num);
        });
      });
      this.$emit("setNum", rs);
    },

    resetData() {
      this.list.forEach((v, index) => {
        v.sku.forEach((n, m) => {
          this.list[index].sku[m].c_num = 0;
        });
      });
    },
    selectAll() {
      this.list.forEach((v, index) => {
        v.sku.forEach((n, m) => {
          this.list[index].sku[m].c_num = Number(n.num);
        });
      });
    },
    /* 恢复不断货 */
    recoveryData() {
      this.$confirm("确定要恢复不断货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          this.$http
            .post("/erp/WcgPlan/removeGoodsFromEmergencyBox", {
              list: this.list,
              pgid: this.pgid,
              supply_id: this.supply_id,
            })
            .then((result) => {
              if (result.data.code != 200) {
                return this.$message.error(result.data.msg);
              }
              // this.$emit('onCloseDialog', {is_fresh:true, num:result.data.data});
              this.$emit("setNum", result.data.data);
              return this.$message.success("操作成功");
            });
        })
        .catch((e) => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style>
.p_table {
  height: 30px;
  margin: 5px 0;
  line-height: 30px;
  text-align: center;
}

.p_table_box {
  width: 100%;
  height: 30px;
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchaseverify/components/StockOutGoods.vue